export type TopProductsRankingPageState = {
  page: number
  offset: number
}

export function topProductsRankingPageForPosition(position: number, perPage: number): TopProductsRankingPageState {
  const safePerPage = Number.isFinite(perPage) ? Math.max(1, Math.trunc(perPage)) : 1
  const safePosition = Number.isFinite(position) ? Math.max(1, Math.trunc(position)) : 1
  const page = Math.ceil(safePosition / safePerPage)

  return { page, offset: (page - 1) * safePerPage }
}

export function isPositionOnPage(position: number, page: number, perPage: number): boolean {
  return topProductsRankingPageForPosition(position, perPage).page === page
}
